import React, { useState, useEffect } from 'react';
import "./HistoryOverview.css" 
import { QuizScreen } from '../../types/GeneralStyles';

const HistoryOverview = () => {
    const [databases, setDatabases] = useState([]);
    const [activeDatabase, setActiveDatabase] = useState('');
  
    useEffect(() => {
      const getDatabases = async () => {
        const databasesList = await indexedDB.databases();
        setDatabases(databasesList.map(db => db.name));
        const currentSessionName = sessionStorage.getItem('currentSessionName') || 'Leerling';
        setActiveDatabase(currentSessionName);
      };
  
      getDatabases();
    }, []);
  
    const handleDatabaseClick = (dbName) => {
      sessionStorage.setItem('currentSessionName', dbName);
      window.location.reload();
    };
  
    const handleDeleteDatabase = (dbName) => {
      const isConfirmed = window.confirm(`Are you sure you want to delete the database: ${dbName}?`);
      if (isConfirmed) {
        const deleteRequest = indexedDB.deleteDatabase(dbName);
        deleteRequest.onsuccess = () => {
          setDatabases(databases.filter(db => db !== dbName));
          if (activeDatabase === dbName) {
            sessionStorage.removeItem('currentSessionName');
            window.location.reload();
          }
        };
        deleteRequest.onerror = (event) => {
          console.error("Error deleting database:", event.target.error);
        };
      }
    };

  return (
    
    <QuizScreen bgVisible="false" id="HistoryOverview">
      <h1>Lokale gegevens overzicht</h1>
      <p>De gegevens worden lokaal op de computer opgeslagen.<br />En nooit naar VRT of een partner van VRT gecommuniceerd.</p>
      <ul>
        {databases.map((db, index) => (
          <li key={index} style={{ fontWeight: db === activeDatabase ? 'bold' : 'normal' }}>
            <button className="listItem" onClick={() => handleDatabaseClick(db)}>
              {db} {db === activeDatabase ? '(Actief)' : ''}
            </button>
            <button className="listItemDelete" onClick={() => handleDeleteDatabase(db)}>
              Verwijder
            </button>
          </li>
        ))}
      </ul>
    </QuizScreen>
  );
};

export default HistoryOverview;
